import React from 'react';

import { PDialog } from '@apigrowfinance/pbolt-dialog';
import { FormattedMessage } from 'react-intl';

import TransactionsFilterForm from '@components/transactions/transactionsFilter/TransactionsFilterForm';
import {
    FilterOptions,
    TransactionFilters,
} from '@pages/transactions/Transactions';
import getEnumTranslation from '@utils/getEnumTranslation';

export type TransactionsFilterDialogProps = {
    filterOptions: FilterOptions;
    setTransactionFilters: React.Dispatch<
        React.SetStateAction<TransactionFilters>
    >;
    transactionFilters: TransactionFilters;
    filterTransactionsOpen: boolean;
    setFilterTransactionsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    refetch?: () => void;
};

const TransactionsFilterDialog = ({
    filterOptions,
    setTransactionFilters,
    transactionFilters,
    filterTransactionsOpen,
    setFilterTransactionsOpen,
    refetch,
}: TransactionsFilterDialogProps) => {
    const handleCloseDialog = () => {
        setFilterTransactionsOpen(false);
    };

    return (
        <PDialog
            dialogTitle={getEnumTranslation('filter')}
            dialogSubtitle={
                <FormattedMessage
                    id="TransactionsFilterModal.filterDesc"
                    defaultMessage="To filter your transactions edit the fields below then click apply."
                />
            }
            onClose={handleCloseDialog}
            open={filterTransactionsOpen}>
            <TransactionsFilterForm
                filterOptions={filterOptions}
                setTransactionFilters={setTransactionFilters}
                transactionFilters={transactionFilters}
                setFilterTransactionsOpen={setFilterTransactionsOpen}
                refetch={refetch}
            />
        </PDialog>
    );
};

export default TransactionsFilterDialog;
